import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { AuthorizationModule } from "../modules/authorization/authorization.module";
import { ApplyModule } from "../modules/pages/apply/apply.module";
import { AttendanceModule } from "../modules/pages/attendance/attendance.module";
import { BusPassApplicationModule } from "../modules/pages/bus-pass-application/bus-pass-application.module";
import { CalendarModule } from "../modules/pages/calendar/calendar.module";
import { DashboardModule } from "../modules/pages/dashboard/dashboard.module";
import { ExamsModule } from "../modules/pages/exams/exams.module";
import { FeesModule } from "../modules/pages/fees/fees.module";
import { GalleryModule } from "../modules/pages/gallery/gallery.module";
import { HomeworksModule } from "../modules/pages/homeworks/homeworks.module";
import { LessonNotesModule } from "../modules/pages/lesson-notes/lesson-notes.module";
import { MessagesModule } from "../modules/pages/messages/messages.module";
import { NoticesModule } from "../modules/pages/notices/notices.module";
import { ProfileModule } from "../modules/pages/profile/profile.module";
import { StudentHistoryModule } from "../modules/pages/student-history/student-history.module";
import { TeachersCommentsModule } from "../modules/pages/teachers-comments/teachers-comments.module";
import { TimetableModule } from "../modules/pages/timetable/timetable.module";
import { PreviousQuestionPaperModule } from "../modules/pages/previous-question-paper/previous-question-paper.module";
import { OnlineExamModule } from "../modules/pages/online-exam/online-exam.module";

export const commonModules: Array<any> = [
    DashboardModule,
    CalendarModule,
    MessagesModule,
    NoticesModule,
    TeachersCommentsModule,
    FeesModule,
    HomeworksModule,
    ExamsModule,
    ProfileModule,
    TimetableModule,
    AuthorizationModule,
    AttendanceModule,
    StudentHistoryModule,
    ApplyModule,
    LessonNotesModule,
    InfiniteScrollModule,
    GalleryModule,
    BusPassApplicationModule,
    PreviousQuestionPaperModule,
    OnlineExamModule
]